import { Component, EventEmitter, Inject, Input, OnInit, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { UserService } from "src/app/core/user.service";
import { ENTITLEMENT } from "src/app/shared/models";
import { DialogWrapper } from "src/app/shared/services/DialogWrapper";
import { ChargebeeService } from "src/app/shared/services/chargebee.service";

@Component({
  selector: 'app-dialog-upgrade',
  templateUrl: './dialog-upgrade.component.html',
  styleUrls: ['./dialog-upgrade.component.scss']
})
export class DialogUpgradeComponent extends DialogWrapper implements OnInit {
  @Input() showDialog!: boolean;
  @Output() showDialogChange = new EventEmitter<boolean>();
  public starredLimit = '3';
  constructor(
    public dialogRef: MatDialogRef<DialogUpgradeComponent>,
    @Inject(MAT_DIALOG_DATA) public matDialogData: {},
    private router: Router,
    private chargebeeService: ChargebeeService,
    private userService: UserService
  ) {
    super();
  }
  ngOnInit(): void {
    this.starredLimit = this.userService.getEntitlement(ENTITLEMENT.FAVORITES).value;
  }

  protected onClickUpgrade = () => {
    this.chargebeeService.gotoHubspotUpgradePage();
    this.close();
  }
}
